import React from "react";

function DistanceTypeSelect({ value, onChange }) {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="distanceTypeSelect" className="form-label">
        Distance Type
      </label>
      <select className="form-select" id="distanceTypeSelect" value={value} onChange={handleChange}>
        <option value="cosine">Cosine</option>
        <option value="euclidean">Euclidean</option>
        <option value="inner_product">Inner Product</option>
      </select>
    </div>
  );
}

export default DistanceTypeSelect;
